export interface NextDeliveryGroupStompMessage {
  scheduleId: string;
  reportedDeliveryGroupKey: string;
  delayDeliveryGroupKey?: string;
}

export interface CompleteScheduleStompMessage {
  scheduleId: string;
}

export interface StartScheduleStompMessage {
  scheduleId: string;
  delayDeliveryGroupKey?: string;
}

export interface UpdateScheduleStompMessage {
  scheduleId: string;
  delayDeliveryGroupKey?: string;
}

export interface CreateScheduleStompMessage {
  scheduleId: string;
}

export enum StompType {
  ScheduleCreate = "SCHEDULE_CREATE",
  ScheduleUpdate = "SCHEDULE_UPDATE",
  ScheduleStart = "SCHEDULE_START",
  ScheduleComplete = "SCHEDULE_COMPLETE",
  ScheduleRefresh = "SCHEDULE_REFRESH",
  NextDeliveryGroup = "NEXT_WORK",
}

export interface CreateScheduleSocketIoMessage {
  scheduleId: string;
}

export interface StartScheduleSocketIoMessage {
  scheduleId: string;
}

export interface UpdateScheduleSocketIoMessage {
  scheduleId: string;
}

export interface CompleteScheduleSocketIoMessage {
  scheduleId: string;
}

export enum SocketIoType {
  ScheduleCreate = "SCHEDULE_CREATE",
  ScheduleMatch = "SCHEDULE_MATCHED",
  ScheduleUpdate = "SCHEDULE_UPDATE",
  ScheduleStart = "SCHEDULE_START",
  ScheduleDelete = "SCHEDULE_DELETE",
  ScheduleComplete = "SCHEDULE_COMPLETE",
  ScheduleRefresh = "REFRESH_SCHEDULE",
  ScheduleRefreshToday = "REFRESH_TODAY_SCHEDULES",
  NextDeliveryGroup = "NEXT_WORK",
  RestartApp = "RESTART_APP",
}
